var _defs, _metadata, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoffeTimeMinify(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 660 502.04",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Coffee Time") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "u",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.0551363
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: -0.11567,
    y: -0.64582,
    width: 1.2313,
    height: 2.2916,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.416547
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.979783
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.7868553
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: -0.09836,
    y: -0.15385,
    width: 1.1967,
    height: 1.3077,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.4609202
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: -0.095948,
    y: -0.30529,
    width: 1.1919,
    height: 1.6106,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4991852
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: -0.19061,
    y: -0.091006,
    width: 1.3812,
    height: 1.182,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6546693
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 382.34,
    x2: 382.34,
    y1: 311.75,
    y2: 751.5,
    gradientTransform: "matrix(.99447 0 0 1 2.0575 -1.5256e-5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    offset: 0.64127
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e6e6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 100.39,
    x2: 608.86,
    y1: 619.81,
    y2: 619.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 101.2,
    x2: 599.07,
    y1: 605.22,
    y2: 627.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 100.15,
    x2: 636.77,
    y1: 590.88,
    y2: 596.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 157.27,
    x2: 593.66,
    y1: 566.14,
    y2: 563.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 230.32,
    x2: 69.141,
    y1: 585.29,
    y2: 585.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 105.38,
    x2: 623.82,
    y1: 579.14,
    y2: 588.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e6e6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e6e6",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 381.84,
    x2: 135.36,
    y1: 607.9,
    y2: 607.9,
    gradientTransform: "translate(128,-66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 255.57,
    x2: 255.57,
    y1: 445.26,
    y2: 484.66,
    gradientTransform: "translate(128,-66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 250.52,
    x2: 138.39,
    y1: 475.57,
    y2: 476.58,
    gradientTransform: "translate(128,-66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    stopOpacity: 0.58371,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 460.75,
    x2: 294.34,
    y1: 415.35,
    y2: 414.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#483737",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241c1c",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 394.29,
    x2: 477.14,
    y1: 570.93,
    y2: 569.51,
    gradientTransform: "translate(118,-66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 423.95,
    x2: 460.82,
    y1: 492.23,
    y2: 580.62,
    gradientTransform: "translate(118,-66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 0.32336
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 390.99,
    x2: 454.69,
    y1: 522.4,
    y2: 574.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3b3b3",
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999",
    offset: 1
  })))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -550.32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.047 275.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.047,
    y: 275.16,
    width: 660,
    height: 502.05,
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.967)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.525)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.7092)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.78469 0 0 .76741 118.74 149.18)",
    d: "m668.72 590.22c0 47.7-138.39 86.368-309.11 86.368s-309.11-38.668-309.11-86.368c0-47.7 138.39-86.368 309.11-86.368s309.11 38.668 309.11 86.368z",
    fill: "#808080",
    filter: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.60791 0 0 .41033 155.14 377.81)",
    d: "m668.72 590.22c0 47.7-138.39 86.368-309.11 86.368s-309.11-38.668-309.11-86.368c0-47.7-125.41-86.115 309.11-86.368 432.63-0.2518 309.11 38.668 309.11 86.368z",
    fill: "url(#n)",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.85652 0 0 .76718 65.741 115.19)",
    d: "m668.72 590.22c0 47.7-138.39 86.368-309.11 86.368s-309.11-38.668-309.11-86.368c0-47.7 138.39-86.368 309.11-86.368s309.11 38.668 309.11 86.368z",
    fill: "url(#m)",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.85652 0 0 .76718 65.741 106.18)",
    d: "m668.72 590.22c0 47.7-138.39 86.368-309.11 86.368s-309.11-38.668-309.11-86.368c0-47.7 138.39-86.368 309.11-86.368s309.11 38.668 309.11 86.368z",
    fill: "url(#l)",
    stroke: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.44 501c-69.341 1.8835-139.98 7.0415-205.38 31.562-12.35 5.2718-25.979 11.623-31.812 24.156-1.1345 11.454 10.859 17.326 19.174 22.476 26.551 14.582 56.815 19.954 86.213 25.947 79.217 14.003 160.55 14.419 240.7 8.1727 47.476-4.3604 95.404-11.691 139.66-29.888 10.475-4.9793 21.984-10.982 27.123-21.645 2.0411-10.634-9.2009-16.733-16.688-21.688-23.793-14.03-51.323-19.206-77.875-25.312-59.539-11.856-120.52-14.487-181.12-13.781zm16.5 23.562c59.542 0.86524 120.55 2.1048 177.34 21.469 9.7369 3.7576 21.294 11.061 21.25 22.719-1.1774 12.685-14.451 18.871-25.094 22.438-37.437 13.622-77.777 15.612-117.19 18.681-68.681 3.7146-138.25 1.7394-205.63-12.775-14.394-3.9282-30.112-8.0676-40.531-19.312-5.9287-8.0854-2.8902-20.434 6.1125-24.944 16.695-12.022 37.995-14.165 57.575-18.65 41.58-7.4742 83.961-9.1029 126.16-9.625z",
    fill: "url(#k)",
    filter: "url(#r)",
    stroke: "#b3b3b3",
    strokeWidth: 0.81062
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.60791 0 0 .41033 155.14 325.81)",
    d: "m668.72 590.22c0 47.7-138.39 86.368-309.11 86.368s-309.11-38.668-309.11-86.368c0-47.7 138.39-86.368 309.11-86.368s309.11 38.668 309.11 86.368z",
    fill: "url(#j)",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.54334 0 0 .32593 178.36 383.16)",
    d: "m668.72 590.22c0 47.7-138.39 86.368-309.11 86.368s-309.11-38.668-309.11-86.368c0-47.7 138.39-86.368 309.11-86.368s309.11 38.668 309.11 86.368z",
    fill: "url(#i)",
    stroke: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.81829 -.051501 .04976 .79064 70.729 147.71)",
    d: "m593.46 566.98c0 11.716-53.028 21.213-118.44 21.213s-118.44-9.4975-118.44-21.213 53.028-21.213 118.44-21.213 118.44 9.4975 118.44 21.213z",
    fill: "#808080",
    filter: "url(#t)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.2599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m231.81 402.47s8 21.277 8 38.604c0 17.328-1.1439 61.949 14.689 85.542 15.832 23.592 42.463 61.709 80.822 67.163 30.651 4.3581 61.301 3.993 91.952 0 38.42-5.0052 65.017-41.171 80.849-67.163 15.832-25.991 14.689-68.214 14.689-85.542 0-17.328 8-38.604 8-38.604z",
    fill: "url(#h)",
    stroke: "#b3b3b3",
    strokeWidth: 1.0034
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0102 0 0 1 27.226 -51.858)",
    d: "m499.02 451.32c0 21.2-66.482 38.386-148.49 38.386-82.01 0-148.49-17.186-148.49-38.386s66.482-38.386 148.49-38.386c82.01 0 148.49 17.186 148.49 38.386z",
    fill: "#e6e6e6",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.93571 0 0 .90672 24.56 37.228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.91 399.44c-0.12268 1.2264 0.39467 2.3723 2 3.0625 12.971 10.363 30.127 12.921 45.656 17 48.607 9.9539 98.83 9.5744 148.12 5.5 27.106-2.8721 54.937-7.5678 79.125-20.625 1.7513-0.94358 3.6192-3.0216 3.8125-4.9375h-278.72z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.83 370.68c-40.648 1.6113-83.07 3.961-119.6 23.175-2.6885 1.4678-5.257 5.9452-1.334 7.6318 12.877 10.288 29.908 12.843 45.325 16.892 48.255 9.8817 98.114 9.4897 147.05 5.4447 26.91-2.8513 54.539-7.513 78.552-20.476 2.7817-1.4988 5.8406-5.8494 1.9545-7.88-11.321-9.2196-26.491-11.805-40.276-15.88-36.456-8.2583-74.339-9.6048-111.68-8.9073z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.83 370.68c-40.648 1.6113-83.07 3.961-119.6 23.175-2.6885 1.4678-5.257 5.9452-1.334 7.6318 12.877 10.288 29.908 12.843 45.325 16.892 48.255 9.8817 98.114 9.4897 147.05 5.4447 26.91-2.8513 54.539-7.513 78.552-20.476 2.7817-1.4988 5.8406-5.8494 1.9545-7.88-11.321-9.2196-26.491-11.805-40.276-15.88-36.456-8.2583-74.339-9.6048-111.68-8.9073z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.27 399.29c-54.225 0-101.22 3.9635-124.4 9.7536 10.543 4.7132 22.37 6.8318 33.364 9.7191 48.255 9.8818 98.109 9.4904 147.05 5.4454 22.972-2.4341 46.472-6.1915 67.796-15.302-23.381-5.7136-70.018-9.6157-123.8-9.6157z",
    fill: "url(#e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m377.25 365.09c-42.107 1.0088-85.468 3.263-124.78 19.156-6.8158 3.2371-16.541 7.301-16.969 16 2.5287 9.0096 12.864 12.415 20.562 15.875 35.245 13.563 73.525 16.005 111 17.458 44.845 0.82389 90.567-1.4926 133.47-15.145 9.8454-3.5415 21.798-7.3996 26.594-17.469 0.74214-7.9313-8.2771-12.465-14.408-15.482-32.362-14.703-68.402-17.233-103.47-19.768-10.658-0.47344-21.33-0.74855-32-0.625zm0.71875 2.0938c40.73 0.49961 82.435 1.5176 121.28 14.875 7.5506 2.6708 17.89 8.1303 16.688 17.594-2.6978 10.355-14.889 13.452-23.722 16.532-37.845 11.255-77.943 12.178-117.25 12.422-36.898-0.52-74.442-2.6827-109.72-14.047-7.668-2.7246-17.549-7.0967-18.781-16.188 0.36766-10.42 12.24-14.675 20.539-17.549 32.31-10.754 66.849-12.18 100.68-13.497 3.4266-0.0856 6.8542-0.12293 10.282-0.14171z",
    fill: "#fff",
    filter: "url(#u)",
    stroke: "#999",
    strokeWidth: 1.0051
  })), /*#__PURE__*/React.createElement("path", {
    d: "m557.34 406.54c-17.258 0-31.022 6.3795-42.595 16.812-10.668 9.156-10.508 32.758-1.8737 34.281 4.923-19.062 22.911-33.125 44.469-33.125 25.371 0 35.781 19.475 35.781 43.656s-18.41 43.625-43.781 43.625c-21.558 0-33.546-8.0386-38.469-27.094-11.182 6.2554-9.3032 19.273-6 28.25 11.573 10.425 27.211 16.812 44.469 16.812 35.816 0 59.768-27.457 59.768-61.594s-15.952-61.625-51.768-61.625z",
    fill: "url(#d)",
    stroke: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.34 406.54c-17.258 0-31.022 6.3795-42.595 16.812-10.668 9.156-10.508 32.758-1.8737 34.281 4.923-19.062 22.911-33.125 44.469-33.125 25.371 0 35.781 19.475 35.781 43.656s-18.41 43.625-43.781 43.625c-21.558 0-33.546-8.0386-38.469-27.094-11.182 6.2554-9.3032 19.273-6 28.25 11.573 10.425 27.211 16.812 44.469 16.812 35.816 0 59.768-27.457 59.768-61.594s-15.952-61.625-51.768-61.625z",
    fill: "url(#c)",
    stroke: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.93574 0 0 .93574 28.092 39.263)",
    d: "m315 588.02c56.393 46.309 171.18 2.5272 182.05-76.595-47.927-82.323-117.78 107.42-182.05 76.595z",
    fill: "url(#b)",
    filter: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(13.571 -.35714)",
    d: "m425.36 426.83c0 3.2545-8.3947 5.8928-18.75 5.8928s-18.75-2.6383-18.75-5.8928c0-3.2545 8.3947-5.8929 18.75-5.8929s18.75 2.6383 18.75 5.8929z",
    fill: "#916f6f",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.73152 0 0 .73152 95.237 121.38)",
    d: "m425.36 426.83c0 3.2545-8.3947 5.8928-18.75 5.8928s-18.75-2.6383-18.75-5.8928c0-3.2545 8.3947-5.8929 18.75-5.8929s18.75 2.6383 18.75 5.8929z",
    fill: "#916f6f",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.88 281.75c-22.547 11.501-21.018 50.608-10.562 72.75 15.106 25.282-0.15307 51.224-3.0938 76.125 21.598 3.8578 22.707-38.005 21.719-56.156-7.2639-27.136-21.918-58.783-3.5625-85.406-0.93989-2.691-1.9906-5.9106-4.5-7.3125zm-45 10c-22.547 10.344-21.018 45.522-10.562 65.438 15.106 22.739-0.15307 46.072-3.0938 68.469 21.598 3.4698 22.707-34.206 21.719-50.531-7.2639-24.407-21.918-52.867-3.5625-76.812-0.93989-2.4204-1.9906-5.3016-4.5-6.5625z",
    fill: "#fff",
    filter: "url(#p)",
    opacity: 0.5251
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeTimeMinify);
export default __webpack_public_path__ + "static/media/coffe-time-minify.122f14f311351a74c24171327543efc3.svg";
export { ForwardRef as ReactComponent };